import type { LinkedRecordCoverImageMode } from "./LinkedRecordCoverImage";

type FileSize = {
  width: number;
  height: number;
};

const SMALL_SIZE = 30;
const LARGE_SIZE = 65;
const SMALL_SIZE_MODES = new Set<LinkedRecordCoverImageMode>(["compact", "table"]);

export const getFileSizeByMode = (mode: LinkedRecordCoverImageMode): FileSize => {
  if (SMALL_SIZE_MODES.has(mode)) {
    return { width: SMALL_SIZE, height: SMALL_SIZE };
  }

  return {
    width: LARGE_SIZE,
    height: LARGE_SIZE,
  };
};
